export default "__VITE_ASSET__BWf1HsHO__"